import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";

// استيراد الفيديوهات
import video1 from "../../src/assets/videos/WhatsApp Video 2025-01-25 at 5.34.47 PM.mp4";
import video2 from "../../src/assets/videos/WhatsApp Video 2025-01-25 at 5.37.09 PM.mp4";
// استيراد صورة الأفران
import foranImage from "../../src/assets/images/foran.png";
// ... استيراد بقية الفيديوهات

interface VideoData {
  video: string;
  title: string;
  isImage?: boolean;
}

const videoData: VideoData[] = [
  {
    video: foranImage,
    title: "أفران نابولي أفران طوب مخابز معجنات",
    isImage: true,
  },
  {
    video: video1,
    title: "نحن نبتكر مشبات تُعبّر عن ذوقك الرفيع وتضفي لمسة من الفخامة على منزلك.",
  },
  {
    video: video2,
    title: "تصميماتنا الفريدة تجمع بين الأصالة السعودية واللمسات العصرية.",
  },
  {
    video: video1, // استبدل هذا بالفيديو الفعلي
    title: "نستخدم أفضل المواد الخام لضمان متانة وجودة لا تُضاهى.",
  },
  {
    video: video2, // استبدل هذا بالفيديو الفعلي
    title: "كل مشبّة نصنعها هي تحفة فنية تُعبّر عن تفاصيل دقيقة وإتقان في العمل.",
  },
  {
    video: video1, // استبدل هذا بالفيديو الفعلي
    title: "تصميمات مخصصة تلبي جميع أذواقك وتتناسب مع مساحات منزلك.",
  },
  {
    video: video2, // استبدل هذا بالفيديو الفعلي
    title: "نهتم بكل التفاصيل، من التصميم الأولي حتى التركيب النهائي.",
  },
  {
    video: video1, // استبدل هذا بالفيديو الفعلي
    title: "مشباتنا ليست مجرد ديكور، بل هي بيئة دافئة تُحيط بك بجمالها.",
  },
  {
    video: video2, // استبدل هذا بالفيديو الفعلي
    title: "نقدم لك تجربة فريدة من التصميم إلى التنفيذ بأعلى معايير الجودة.",
  },
  {
    video: video1, // استبدل هذا بالفيديو الفعلي
    title: "فريقنا من الحرفيين المهرة يضمن لك نتائج مبهرة تُضفي طابعًا من الفخامة.",
  },
  {
    video: video2, // استبدل هذا بالفيديو الفعلي
    title: "نسعى دائمًا لتجاوز توقعاتك، لأنك تستحق الأفضل.",
  },
];

const ProjectsVideos: React.FC = () => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const { t } = useTranslation();

  const handleNext = () => {
    setCurrentVideoIndex((prevIndex) =>
      prevIndex === videoData.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevious = () => {
    setCurrentVideoIndex((prevIndex) =>
      prevIndex === 0 ? videoData.length - 1 : prevIndex - 1
    );
  };

  return (
    <React.Fragment>
      <section className=" portfolio business-portfolio" id="work">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6}>
              <motion.div
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="text-center"
              >
                <div className="text-center">
                  <h2
                    className="heading-title-title text-uppercase"
                    style={{
                      fontSize: "50px",
                      position: "relative",
                      display: "inline-block",
                    }}
                  >
                    {t("portfolio.recentProjects")}
                    <span
                      style={{
                        display: "block",
                        width: "100px",
                        height: "4px",
                        backgroundColor: "#000",
                        margin: "10px auto 0",
                      }}
                    ></span>
                  </h2>
                </div>
              </motion.div>
            </Col>
          </Row>
          <AnimatePresence mode="wait">
            <motion.div
              key={currentVideoIndex}
              variants={{
                hidden: { opacity: 0 },
                visible: { opacity: 1 },
                exit: { opacity: 0 },
              }}
              initial="hidden"
              animate="visible"
              exit="exit"
              transition={{ duration: 0.5 }}
            >
              <Row className="align-items-center my-5">
  <Col
    lg={6}
    md={6}
    sm={12}
    className={currentVideoIndex % 2 === 0 ? "order-lg-1" : "order-lg-2"}
  >
    {videoData[currentVideoIndex].isImage ? (
      <img
        src={videoData[currentVideoIndex].video}
        alt={videoData[currentVideoIndex].title}
        style={{
          height: "500px",
          objectFit: "cover",
          width: "100%",
          outline: "none",
          border: "2px solid #ddd",
        }}
      />
    ) : (
      <video
        style={{
          height: "500px",
          objectFit: "cover",
          width: "100%",
          outline: "none",
          border: "2px solid #ddd",
        }}
        autoPlay
        muted
        loop
      >
        <source
          src={videoData[currentVideoIndex].video}
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    )}
  </Col>

  <Col
    lg={6}
    md={6}
    sm={12}
    className={currentVideoIndex % 2 === 0 ? "order-lg-2" : "order-lg-1"}
  >
    <h3
      className="text-center mt-3"
      style={{
        fontSize: "32px",
        fontWeight: "bold",
        lineHeight: "50px",
        color: "#333",
      }}
    >
      {t(`videos.${currentVideoIndex}`)}
    </h3>
  </Col>
</Row>





            </motion.div>
          </AnimatePresence>

          <Row className=" my-4 justify-content-center">
            <Col lg={8} md={10} sm={12} className="d-flex justify-content-between">
              <Button variant="dark" onClick={handlePrevious}>
                {t("back")}
              </Button>
              <Button variant="dark" onClick={handleNext}>
                {t("next")}
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default ProjectsVideos;